import { IChangeCourseOfferingCategoryActionPayload } from '../interfaces/change-course-offering-category.action.payload.interface';

export class ChangeCourseOfferingCategoryCommand {
    category: { id: string };

    constructor(tempCourseOfferingGroupReq: IChangeCourseOfferingCategoryActionPayload) {
        this.category = tempCourseOfferingGroupReq.category;
    }
}
